import immutabilityHelper from 'immutability-helper'

export const createStack = (...vals) => vals

export const push = (stack, newValue) => {
  return immutabilityHelper(stack, {
    $splice: [[0, 0, newValue]],
  })
}

export const peek = (stack, offset = 0) => {
  return stack[offset]
}

export const pop = stack => {
  const head = stack[0]
  const newStack = immutabilityHelper(stack, {
    $splice: [[0, 1]],
  })

  return [head, newStack]
}
